import { useQuery } from '@tanstack/react-query'
import type { ServiceDetailResponse } from 'shared'
import { apiGet } from '../lib/api'

export function useService(id: string | undefined) {
  return useQuery({
    queryKey: ['service', id],
    queryFn: ({ signal }) => apiGet<ServiceDetailResponse>('/services/' + id, signal),
    enabled: !!id,
  })
}
